import { lazyLoad } from './lazyload-init.js';

// Document ready
$(function(){

    /* Neighbourhood Heroes Content Archive */
    
    var $contentArchive = $('#neighbourhood-heroes.content-archive.custom-template');

    if( $contentArchive.length ) {
        var $contentButtons = $contentArchive.find('.item-content-show-js');
        var $colContentContaners = $contentArchive.find('.col-content-container');
        let lazyLoadInstance  = lazyLoad(); // Add lazyLoad  

        // Button click
        $contentButtons.on('click', function() {
            var $contentActiveBtn = $(this); // Active btn
            var $contentActiveItem = $contentActiveBtn.closest('.list-item'); // Active list item
            var contentActiveBtnIndex = $contentActiveItem.data('index'); // List item ID
            var parentID = $contentActiveBtn.data('parent-id'); // Content Parent ID
            var $parentList = $('#'+parentID).find('.content-list'); // $Content List container
            var $parentContent = $('#'+parentID).find('.content-archive-container'); // $Content contaner
            var contentID = $contentActiveBtn.data('content-id'); // Content ID
            var ItemContentOutput = '';

            // Check first content container visibilityy
            var $colContentContainer = $contentActiveItem.nextAll(".col-content-container:visible").first();
            var colContentContainerSize = $colContentContainer.data('container-size');

            // If NOT active
            if( !$contentActiveItem.hasClass('is-active') ) {
                // Reset all other Items
                // Remove active states
                $parentList.find('.is-active').addClass('is-busy').removeClass('is-active'); // Item active
                //$parentList.find('.is-hidden').removeClass('is-hidden'); // items show hidden
                // Fix for index issue
                setTimeout(() => {
                    $parentList.find('.is-busy').removeClass('is-busy')
                }, 800);
                $colContentContaners.removeClass('has-content'); // Col Content Container
                // Reset END

                // Set Item active states
                $contentActiveItem.addClass('is-active'); // Current item active

                // Set the content
                ItemContentOutput = $parentContent.find('#'+contentID).clone();
                $colContentContainer.html(ItemContentOutput);
                lazyLoadInstance.update(); // Update LazyLoad
                setTimeout(() => {
                    $colContentContainer.addClass('has-content');
                }, 50);
                // Hide all items afer col content open if not mobile/tablet
                if( colContentContainerSize != 'xs' ) {
                    setTimeout(() => {
                        $colContentContainer.nextAll('.list-item').addClass('is-hidden').hide();
                    }, 100);
                }
                

            } else {
            }
        });

        // Back button
        $contentArchive.on('click', '.btn-back', function() {
            var parentID = $(this).data('parent-id'); // Content Parent ID
            var $parentList = $('#'+parentID).find('.content-list'); // $Content List container
            $parentList.find('.is-active').addClass('is-busy').removeClass('is-active'); // Item active
            $parentList.find('.is-hidden').removeClass('is-hidden').show();
            // Fix for index issue
            setTimeout(() => {
                $parentList.find('.is-busy').removeClass('is-busy')
            }, 800);
            $colContentContaners.removeClass('has-content');
        });
    }
});